/**
 * @author        patrick@zumper.com (Patrick Giddings)
 * @copyright     Copyright (c) 2023, Zumper
 * @description   mappings of traktor events to optimizely events
 */

import { USER_ENGAGEMENT_CONTACT, USER_ENGAGEMENT_GENERAL } from './optimizelyEvents.constants'
import type { OptimizelyEvent } from './types'

export const TRAKTOR_EVENT_TO_OPTIMIZELY_EVENTS: Readonly<
  Partial<Record<string, OptimizelyEvent>>
> = {
  DETAIL_ALERT: USER_ENGAGEMENT_CONTACT,
  DETAIL_CALL: USER_ENGAGEMENT_CONTACT,
  DETAIL_FAVORITE: USER_ENGAGEMENT_CONTACT,
  DETAIL_MESSAGE: USER_ENGAGEMENT_CONTACT,
  DETAIL_MESSAGE_SIMILAR: USER_ENGAGEMENT_CONTACT,
  DETAIL_MULTI_MESSAGE: USER_ENGAGEMENT_CONTACT,
  EMAIL_ENTERED: USER_ENGAGEMENT_CONTACT,
  LIST_ITEM_CALL: USER_ENGAGEMENT_CONTACT,
  LIST_ITEM_FAVORITE: USER_ENGAGEMENT_CONTACT,
  LIST_ITEM_MESSAGE: USER_ENGAGEMENT_CONTACT,
  LIST_ITEM_MULTI_MESSAGE: USER_ENGAGEMENT_CONTACT,
  MAP_LIST_ALERT: USER_ENGAGEMENT_CONTACT,
  MOVE_IN_ENTERED: USER_ENGAGEMENT_CONTACT,
  NAME_ENTERED: USER_ENGAGEMENT_CONTACT,
  PERMANENT_ADDRESS_MESSAGE: USER_ENGAGEMENT_CONTACT,
  PHONE_ENTERED: USER_ENGAGEMENT_CONTACT,
  RELATED_MM_FAVORITE: USER_ENGAGEMENT_CONTACT,
  SIGNUP: USER_ENGAGEMENT_CONTACT,
  TOUR_BOOKING_SUBMIT_CLICK: USER_ENGAGEMENT_CONTACT,
  UNDO_MESSAGE: USER_ENGAGEMENT_CONTACT,
  UNDO_TOUR: USER_ENGAGEMENT_CONTACT,
  _HOOD_COMPARE_WIDGET_CLICK_BED_DROPDOWN: USER_ENGAGEMENT_GENERAL,
  _HOOD_COMPARE_WIDGET_CLICK_HOOD_2_DROPDOWN: USER_ENGAGEMENT_GENERAL,
  GALLERY_SHARE_CLICK: USER_ENGAGEMENT_GENERAL,
  _HOOD_COMPARE_WIDGET_CLICK_HOOD_1_DROPDOWN: USER_ENGAGEMENT_GENERAL,
  _SCHOOL_WIDGET_CLICK_TAB: USER_ENGAGEMENT_GENERAL,
  '[Related MM] Click detail page': USER_ENGAGEMENT_GENERAL,
  AUTOCOMPLETE_RESULT_CLICK: USER_ENGAGEMENT_GENERAL,
  BUTTON_CLICKED: USER_ENGAGEMENT_GENERAL,
  CLICK_MESSAGE: USER_ENGAGEMENT_GENERAL,
  CLICK_TOUR_AVAILABILITY: USER_ENGAGEMENT_GENERAL,
  DATE_PICKER_CLICK: USER_ENGAGEMENT_GENERAL,
  DETAIL_AMENITIES: USER_ENGAGEMENT_GENERAL,
  DETAIL_OFFPLATFORM_CLICK: USER_ENGAGEMENT_GENERAL,
  DETAIL_SHARE: USER_ENGAGEMENT_GENERAL,
  EXPLORE_NEARBY_RENTALS_BY_LIFESTYLE_CLICK: USER_ENGAGEMENT_GENERAL,
  FILTER_CHANGE: USER_ENGAGEMENT_GENERAL,
  FLOORPLAN_CLICK: USER_ENGAGEMENT_GENERAL,
  FLOORPLAN_SELECTED: USER_ENGAGEMENT_GENERAL,
  GREAT_FOR_LIFESTYLE_CLICK: USER_ENGAGEMENT_GENERAL,
  HTML_MESSAGE_CLICK: USER_ENGAGEMENT_GENERAL,
  LINK_CLICKED: USER_ENGAGEMENT_GENERAL,
  LIST_CAROUSEL_CLICK: USER_ENGAGEMENT_GENERAL,
  LIST_ITEM_CLICK: USER_ENGAGEMENT_GENERAL,
  LLM_DESCRIPTION_FEEDBACK_NEGATIVE: USER_ENGAGEMENT_GENERAL,
  LLM_DESCRIPTION_FEEDBACK_POSITIVE: USER_ENGAGEMENT_GENERAL,
  LOCATION_CHANGE: USER_ENGAGEMENT_GENERAL,
  MAP_LIST_FILTER_BAR_CLICK: USER_ENGAGEMENT_GENERAL,
  MAP_LIST_POI_APPLY_BUTTON_CLICK: USER_ENGAGEMENT_GENERAL,
  MAP_LIST_POI_CATEGORY_BUTTON_CLICK: USER_ENGAGEMENT_GENERAL,
  MAP_LIST_POI_CLEAR_BUTTON_CLICK: USER_ENGAGEMENT_GENERAL,
  MAP_LIST_POI_MAP_MARKER_PIN_CLICK: USER_ENGAGEMENT_GENERAL,
  MAP_LIST_POI_MAP_MARKER_POPOVER_CLOSE_CLICK: USER_ENGAGEMENT_GENERAL,
  MAP_LIST_POI_NEARBY_BUTTON_CLICK: USER_ENGAGEMENT_GENERAL,
  MAP_LIST_POI_RESULTS: USER_ENGAGEMENT_GENERAL,
  MOST_AFFORDABLE_CLICK: USER_ENGAGEMENT_GENERAL,
  MOST_POPULAR_CLICK: USER_ENGAGEMENT_GENERAL,
  NAVBAR_CLICK: USER_ENGAGEMENT_GENERAL,
  PIN_CLICK: USER_ENGAGEMENT_GENERAL,
  POPULAR_AMENITIES_FILTER_CLICK: USER_ENGAGEMENT_GENERAL,
  POPULAR_FILTERS_LTR: USER_ENGAGEMENT_GENERAL,
  RENT_CALCULATOR: USER_ENGAGEMENT_GENERAL,
  SEARCH_QUESTIONS_COMPLETION: USER_ENGAGEMENT_GENERAL,
  SHORT_TERM_CLICK_OUT: USER_ENGAGEMENT_GENERAL,
  SWEET_DEALS_CLICK: USER_ENGAGEMENT_GENERAL,
  TRACK_PRICE_CLICK: USER_ENGAGEMENT_GENERAL,
  VIRTUAL_3D_TOUR_PLAY: USER_ENGAGEMENT_GENERAL,
  VIRTUAL_VIDEO_TOUR_PLAY: USER_ENGAGEMENT_GENERAL,
  ZOE_ENTRY_CLICK: USER_ENGAGEMENT_GENERAL,
  ZOE_TOGGLE_CLICK: USER_ENGAGEMENT_GENERAL,
  ZOE_DEFAULT_QUESTION_SUGGESTION_CLICK: USER_ENGAGEMENT_GENERAL,
  ZOE_FOLLOW_UP_QUESTION_SUGGESTION_CLICK: USER_ENGAGEMENT_GENERAL,
  ZOE_QUESTION_SEND: USER_ENGAGEMENT_GENERAL,
}
